export default class Dashboard {
  constructor(channel = null, complete_exercises = null, draft_classes = null, incomplete_exercises = null, playbooks = null, published_classes = null, templates = null, unlabeled_exercise_videos = null, stripe_connected = null, trainer_relationship = null) {
    this.channel = channel;
    this.complete_exercises = complete_exercises;
    this.draft_classes = draft_classes;
    this.incomplete_exercises = incomplete_exercises;
    this.playbooks = playbooks;
    this.published_classes = published_classes;
    this.templates = templates;
    this.unlabeled_exercise_videos = unlabeled_exercise_videos;
    this.stripe_connected = stripe_connected;
    this.trainer_relationship = trainer_relationship;
  }
}
